/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.58" height="71.07" viewBox="0 0 95.58 71.07" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g>
          <path d="M84.19,42A1.86,1.86,0,0,1,86,43.72V59.49h-2.5v-15H71v15h-2.5V43.86A1.85,1.85,0,0,1,70.25,42H84.19Z" transform="translate(-29.5 -42)" fill="#0e497b"/>
          <path d="M89.86,58.24A1.25,1.25,0,0,1,90,60.73H64.72a1.25,1.25,0,0,1-.13-2.49H89.86Z" transform="translate(-29.5 -42)" fill="#0e497b"/>
          <path d="M69.79,51.43v2.5H37.05a5.07,5.07,0,0,0-5,4.83v46.76a5.05,5.05,0,0,0,4.83,5h80.71a5.06,5.06,0,0,0,5-4.83V59a5.06,5.06,0,0,0-4.83-5H84.8v-2.5h32.74a7.55,7.55,0,0,1,7.54,7.3v46.79a7.54,7.54,0,0,1-7.3,7.54H37.05a7.56,7.56,0,0,1-7.55-7.31V59a7.56,7.56,0,0,1,7.3-7.55h33Z" transform="translate(-29.5 -42)" fill="#0e497b"/>
          <path d="M114.84,73.59a1.25,1.25,0,0,1,.13,2.49H83.35a1.25,1.25,0,0,1-.13-2.5h31.62Z" transform="translate(-29.5 -42)" fill="#0e497b"/>
          <path d="M114.84,83a1.25,1.25,0,0,1,.13,2.5H83.35A1.25,1.25,0,0,1,83.22,83h31.62Z" transform="translate(-29.5 -42)" fill="#0e497b"/>
          <path d="M114.84,92.48A1.25,1.25,0,0,1,115,95H83.35a1.25,1.25,0,0,1-.13-2.49h31.62Z" transform="translate(-29.5 -42)" fill="#0e497b"/>
          <path d="M74.06,84.28A17.16,17.16,0,1,1,56.9,67.13,17.16,17.16,0,0,1,74.06,84.28" transform="translate(-29.5 -42)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M56.9,87.45a18.35,18.35,0,0,1,14.31,6.83,1.25,1.25,0,1,1-1.94,1.57,15.92,15.92,0,0,0-24.74,0,1.25,1.25,0,1,1-2-1.57A18.39,18.39,0,0,1,56.9,87.45Z" transform="translate(-29.5 -42)" fill="#fefefe"/>
          <path d="M56.9,72.36a8.8,8.8,0,1,0,8.79,8.8A8.79,8.79,0,0,0,56.9,72.36Zm0,2.5a6.3,6.3,0,1,1-6.29,6.3A6.3,6.3,0,0,1,56.9,74.86Z" transform="translate(-29.5 -42)" fill="#fefefe"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'IdentificationBadgeIcon';

export default Icon;
